<template>
  <div>
    <b-pagination size="md" 
      :total-rows="msgItemCount" 
      v-model="tableOption.pageNumber" 
      :per-page="tableOption.perPage"
      @input="changePage"
      >
    </b-pagination>
    <b-table striped hover 
      :items="msgItems" 
      :fields="tableOption.fields"
    >
      <template v-slot:cell(actions)="row">
        <b-button size="sm" @click.stop="PopupDisplay(row)" class="mr-1">
          查看訊息
        </b-button>
        <b-button size="sm" @click.stop="confirmReadMsg(row)" class="mr-1">
          確認已讀
        </b-button>
      </template>
    </b-table>
    <b-pagination size="md" 
      :total-rows="msgItemCount" 
      v-model="tableOption.pageNumber" 
      :per-page="tableOption.perPage"
      @input="changePage"
      >
    </b-pagination>
    <b-modal id="msgConfirm" ref="modalConfirm" v-model="showMsg" v-show="showMsg"
    :title="popupRow.item.type_title" 
    :content="popupRow.item.msg_body"
    @ok="confirmReadMsg(popupRow)"
    >
      <div>
        {{popupRow.item.msg_body}}
      </div>
    </b-modal>
  </div>

</template>

<script>

export default {
  // 為了練習好paged table模式,這個組件不僅是做內容結果container,而是商家總管理的重要訊息的完整功能組件
  // 包含查詢條件,一整顆被放到MerchantAdminInfo就好(獨立呼叫api抓應顯示數據而不由parent傳prop)
  name: 'PagedMsgTable',
  data: function () {
    return {
      popupRow: {
        index:-1,
        item: {
          type_title:'',
          msg_body:'',
          mwct_id:0,
          is_confirmed:0
        }
      },
      showMsg: false,
      displayingMsg: '',
      popupReadId: -1,
      msgItems: [],
      msgItemCount: 0,
      cachedPageData:Object,
      tableOption: {
        perPage:10,
        pageNumber:1,
        fields: [
          {
            key: 'mwct_id',
            label: 'id',
            sortable: false
          },
          {
            key: 'type_title',
            label: '主題',
            sortable: false
          },
          {
            key: 'msg_time',
            label: '訊息時間',
            sortable: true
          },
          {
            key: 'is_confirmed',
            label: '已讀',
            sortable: false
          },
          {
            key: 'actions',
            label: '功能',
            sortable: false
          },
        ]
      },
      
    }
  },
  props: [
      'MsgItems',
    ],
  methods: {
    changePage() {
      // 切換msgItems...alert不出來但cache確實有用
      if (this.cachedPageData && this.cachedPageData['P_'+this.tableOption.pageNumber]) {
        this.msgItems = this.cachedPageData['P_'+this.tableOption.pageNumber]
      }
      else {
        this.loadMsgItems()
      }
    },
    loadMsgItems () {
      let Param = {
        'module':'merchant',
        'method':'getNotifications',
        'merchant_id':this.$bus.session.merchant_id,
        'query_start_date':'2018-07-01',
        'query_end_date':'2018-12-01',
        'page_number':this.tableOption.pageNumber,
        'items_per_page':this.tableOption.perPage
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
          }
          // eslint-disable-next-line
          vm.msgItems = data.data.msg_list
          if (data.data.msg_count) {
            vm.msgItemCount = data.data.msg_count
          }
          if (vm.tableOption.pageNumber === 1) {
            vm.cachedPageData = Object
          }
          vm.cachedPageData['P_'+vm.tableOption.pageNumber] = data.data.msg_list
      },this)
    },
    PopupDisplay: function (row) {
      this.popupRow = row
      this.showMsg = true;
    },
    confirmReadMsg(row) {
      if (row) {
        this.popupRow = row
      }

      // 商家目前沒支援確認訊息已讀的api接口啊= =
      //return
      let qryBody = {
        'module':'user_notify_task',
        'method':'confirmTaskNotify',
        'mwct_id': this.popupRow.item.mwct_id
      }
      // this.popupReadId = this.popupRow.item.mwct_id
      this.$bus.apiCall(qryBody, function (data, vm) {
        if (data.ok == 1) {
          vm.msgItems[vm.popupRow.index].item.is_confirmed = 1
        }
        else {
          // 寫假的看效果= = 
          vm.msgItems[vm.popupRow.index].is_confirmed = 1
        }
      },this)
    },
    reload () {
      this.msgItems = []
      this.tableOption.pageNumber = 1
      this.loadMsgItems()
    }
  },
  created () {
    this.loadMsgItems()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.unread {
  background-color: aquamarine;
}

</style>
